export default __webpack_public_path__ + "static/media/cars.74792ee2.svg";